import styled from "styled-components/macro";

export const ExternalForwardFetalSexHeaderIcon = styled.img<{ width: string }>`
  width: ${({ width }) => width};
  margin: auto;
  height: inherit;
`;

export const ExternalForwardFetalSexHeaderIconsLinksContainer = styled.div`
  display: flex;
`;

export const ExternalForwardFetalSexHeaderContainer = styled.div`
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.11);
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 60px;
  background: ${({ theme }) => theme.headerBackground};
`;

export const ExternalForwardFetalSexHeaderIconsContainer = styled.div`
  display: flex;
  align-items: center;
  padding-left: 50px;
`;

export const ExternalForwardFetalSexInfoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 50px;
`;

export const ExternalRevealClosing = styled.div`
  max-width: 600px;
  padding: 0 10px;
`;

export const ExternalRevealResultWrapper = styled.div`
  isolation: isolate;
  overflow: hidden;
  position: relative;
`;

export const ExternalRevealResultContent = styled.div`
  position: relative;
  z-index: 1;
`;

export const ExternalRevealGrid = styled.div`
  display: grid;
  grid-template-rows: 40px auto;
  grid-row-gap: 20px;
`;
